import { Component, ViewChild, OnInit, ViewEncapsulation, TemplateRef, Output, Input, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import { Router} from '@angular/router';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';

//Model
import { FileExport } from '../../../model/exporter.model';
import { Url } from '../../../model/users.model';
import { User } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';
import { Fuel, FuelItem} from '../../../model/newfuels.model';

//Service
import { FilesService } from '../../../services/files.service';
import { ExportService } from '../../../services/exporter.service';
import { NewfuelService } from '../../../services/newfuels.service';
import { PrintService } from './../../../services/print.service';

@Component({
  selector: 'app-newfuels',
  templateUrl: './newfuels.component.html',
  styleUrls: ['../../datatable.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [NewfuelService,FilesService]
})

export class NewfuelsComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() user: User;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;

    public fuelDateRange: any =[];
    public fuelItemDateRange: any = [];

    locale: any = {
        format: 'DD MMMM YYYY',
        displayFormat: 'DD MMMM YYYY',
        separator: ' to ',
        cancelLabel: 'Cancel',
        applyLabel: 'OK',
      }

    fuel_rows = [];
    tyre_rows = [];
    insurance_rows = [];
    registration_rows = [];
    othercost_rows = [];
    items_rows = []; 
    drivers = [];
    driversActive = [];
    fleet = [];
    fleetActive= [];
    tempNewItems = []; //temporary array for new items
    tempItems: FuelItem[];// for existing items
    fuel_cards = [];
    fuel_cards_all = [];
    selected = [];
    selected2 = []
    fuel_type = [
    {id: 1, name:"Diesel"},
    {id: 2, name:"Ad Blue"},
    {id: 3, name:"Gas"},
    {id: 4, name:"Oil"},
    {id: 5, name:"Others"},
    ];
    is_image:any;
    allproviders = [];
    providers = [];

    loadingIndicator: boolean = true;
    loadingIndicator2: boolean = true;
    reorderable: boolean = true;
    isEditMode: boolean = false;
    public readonly prefixFuel = 'fuel';
    public readonly prefixItem = 'fuelData'
    public showSidebar : boolean = false;
    public showItem : boolean = false;


    fuelYearly: number;
    fuelMonthly: number;
    fuelWeekly: number;
    fuelRecentCost: number;
    fuelRecentRego: string;
    fuelRecentDate: string;

    public fuelForm: FormGroup; 
    public modalRef: NgbModalRef;
    public itemForm: FormGroup;
    public fuel: Fuel;
    public frmFile: any;

    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;
    public oldDocketFile: string;

    fuelData = [];
    tempTotal: number = 0;
    tempLiter: number = 0;
    grandLiter: number = 0;
    grandTotal: number = 0;

    dateNow:any;

    //Filter Codes

    showDate:boolean=true;
    showWeekNo:boolean=true;
    showRego:boolean=true;
    showFleetID:boolean=true;
    showDriver:boolean=true;
    showCustomer:boolean=true;
    showSupplier:boolean=true;
    showCardNo:boolean=true;
    showCost:boolean=true;
    showLitres:boolean=true;
    showFile:boolean=true;

    showDateCreated:boolean=true;
    showFuelItems_WeekNo:boolean=true;
    showFuelItems_FuelID:boolean=true;
    showFuelItems_Rego:boolean=true;
    showFuelItems_FleetID:boolean=true;
    showProduct:boolean=true;
    showRate:boolean=true;
    showQuantity:boolean=true;
    showTotal:boolean=true;
    myDropDown='7'; //initialize to 7 days
    fuelItemDateDropdown = '7';

    showFilters: boolean = false;

    filterFuelRego: string = '';
    filterFuelProvider: string = '';
    filterFuelDateFrom: Date;
    filterFuelDateTo: Date;

    filterItemFuelId: string = '';
    filterItemProvider: string = '';
    filterItemDateFrom: Date;
    filterItemDateTo: Date;

    filterCustomer: string = '';
    filterFuelItemProduct : string = '';
    filterLiter: any;
    filterCost: any;
    filterItemCost:any;
    filterItemProduct: any;

    isFilterEmpty: boolean = true;
    fullRowsFuel: any;
    fuelCount = 0;
    tempItem = [];
    fullRowsItem = [];
    itemCount = 0;
    tempFuelCount = 0;
    tempFuelTotalLiter = 0;
    tempFuelTotalCost = 0;
    tempFuelAvgCost = 0;

    tempItemCount = 0;
    tempItemTotalLiter = 0;
    tempItemTotalCost = 0;
    tempItemAvgCost = 0;
    titleLogoURL: string;

    manifests =[];

    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list : any;

    public readonly prefixFleetAssets = "fleetassets";
    public readonly prefixFleetDetails = "fleetdetails";

    @Input() parent: string;
    @Input() fleet_id :number; 

    @Output() refreshData : EventEmitter<any>= new EventEmitter<any>();
    @ViewChild('modalFuel', {static: false}) modalFuel: TemplateRef<any>;
    @ViewChild('modalItem', {static: false}) modalItem: TemplateRef<any>;
    @ViewChild('modalDeleteFuel', { static: false }) modalDeleteFuel: TemplateRef<any>;
    @ViewChild('modalDeleteItem', { static: false }) modalDeleteItem: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;

    item: FuelItem;
    tempFuel: any;
    totalAmount: any;
    totalLitres: any;
    totalFuelAmount: any;
    totalFuelLitres: any;
    totalFuels: number = 0;
    averageFuelAmount: any;

    totalFuelItemAmount: any;
    totalFuelItemLitres: any;
    totalFuelItems: number = 0;
    averageFuelItemAmount: any;

    dateFilter='Last 7 Days';
    fuelItemDateFilterLabel = "Last 7 Days";

    maxDate: moment.Moment = moment();

    oldPic:any;
    old64:any;
    spinner: boolean = false;

    constructor(private http: HttpClient, private _fb: FormBuilder, private modal: NgbModal, 
            private fileService: FilesService, private NewfuelService: NewfuelService, 
            private toaster: ToastrService, private route: Router, private exporter: ExportService,
            public printer: PrintService){
                this.titleLogoURL = this.url.rest + '/images/title_logo.jpg';
            }

    ngOnInit() {
        this.initFuelForm();
        this.initItemForm();

        this.dateNow = new Date().toLocaleString();

        //Declaration to handle the name, type and content of the file
        this.exp_excel = {title:'', list_data:'', type:''};
        this.exp_pdf = {title:'', list_data:'', type:''};

        this.NewfuelService.getFuelMiscData().subscribe(result=>{
            this.drivers = result["drivers"];
            this.fleet = result["fleet"];
            this.providers = result ["providers"];
        });

        this.getFuels(this.myDropDown);
        this.getItems(this.fuelItemDateDropdown);
        this.getFuelDashboard();

        //getting all cards
        this.NewfuelService.getAllFuelCards().subscribe(data => {
            this.fuel_cards_all = data['fuel_cards'];
        });

        this.tempTotal = 0; 
        this.tempLiter = 0;
        this.grandLiter = 0; 
        this.grandTotal = 0;
        this.tempNewItems = [];
        this.tempItems=[];

        this.resetFileVariables();
        this.showItem = false;
    }
  
    async getFuels(myDropdown, start='', end=''){
        setTimeout(() => {},100);
        if(this.parent == this.prefixFleetDetails){
            await this.NewfuelService.getFuelWithItemsByFleetId(this.fleet_id, myDropdown,start,end).toPromise().then(data=>{
                this.fuel_rows = data['fuel'];
                if (typeof this.fuel_rows != "undefined"  && this.fuel_rows != null  
                && this.fuel_rows.length != null  && this.fuel_rows.length > 0) {
                    this.selected = [this.fuel_rows[0]];
                    this.getFuelItemsByFuel(this.selected[0].id, 'loading');
                    this.fuelCount = Object.keys(this.fuel_rows).length;
                } 
                else{
                    this.selected=[];
                  }               
                this.computeFuelSubtotals();
                this.fullRowsFuel = this.fuel_rows;
                this.tempFuel = this.fuel_rows;
            });
                setTimeout(() => { this.loadingIndicator = false; });
        }else{
            await this.NewfuelService.getFuels(myDropdown, start, end).toPromise().then(data => {
                this.fuel_rows = data['fuel'];
                this.computeFuelSubtotals();
                if (typeof this.fuel_rows != "undefined"  && this.fuel_rows != null  
                && this.fuel_rows.length != null  && this.fuel_rows.length > 0) {
                    this.selected = [this.fuel_rows[0]];
                    this.getFuelItemsByFuel(this.selected[0].id, 'loading');
                    this.fuelCount = Object.keys(this.fuel_rows).length;
                }
                this.fullRowsFuel = this.fuel_rows;
                this.tempFuel = this.fuel_rows;
            });
            setTimeout(() => { this.loadingIndicator = false; });
        }
    }

    async getItems(filter = '', start='', end=''){
        this.loadingIndicator2 = true;
        this.fullRowsItem = [];
        this.tempItems = [];
        this.itemCount = 0;

        if(this.parent == this.prefixFleetDetails){
            await this.NewfuelService.getFuelItemsByFleetId(this.fleet_id,filter, start, end).toPromise().then(result=>{
                this.fuelData = result['fuel_items'];
                this.computeFuelItemSubtotals();
                this.fullRowsItem = this.fuelData; //for items
                this.itemCount = Object.keys(this.fuelData).length;
            });
                setTimeout(() => { this.loadingIndicator2 = false; });
        }else{
            console.log('getting items ', this.fuelItemDateDropdown);
            await this.NewfuelService.getFuelItems(filter, start, end).toPromise().then(result => {
                this.fuelData = result['fuel_items'];
                this.computeFuelItemSubtotals();
                this.fullRowsItem = this.fuelData; //for items
                this.itemCount = Object.keys(this.fuelData).length;
            });
            setTimeout(() => { this.loadingIndicator2 = false; });
        }
    }

    public getFuelItemsByFuel(fuel_id, caller){
        this.tempItems = [];
        this.itemCount = 0;
        this.grandLiter = 0;
        this.grandTotal = 0; 
        this.NewfuelService.getItemsByFuelId(fuel_id).subscribe(result=>{
            
            switch(caller){
                case ('modal'):  {
                    if(this.isEditMode){
                        this.tempItems = result['fuel_items'];
                        this.tempItems.forEach(item=>{
                        this.grandLiter += item.quantity;
                        this.grandTotal += item.total;
                        this.itemCount++});
                    }else{
                        this.tempItems = [];
                        this.grandLiter = 0;
                        this.grandTotal = 0.00;
                    }
                    this.fuelForm.controls.fuel_items.setValue(this.tempItems);

                break;};

                case ('loading'): {this.selected[0].fuel_items = result['fuel_items'];break;};
                default:break;
            }
        });
    }

    async getFuelDashboard(){
        if(this.parent == this.prefixFleetDetails){
            await this.NewfuelService.getFuelSummaryByFleetId(this.fleet_id).toPromise().then(data=>{
                this.fuelYearly = data['fuel_yearly'];
                this.fuelMonthly = data['fuel_monthly'];
                this.fuelWeekly = data['fuel_weekly'];
                this.fuelRecentCost = data['fuel_recent_cost'];
                if( data['fuel_recent_rego'] !== null){
                    this.fuelRecentRego = data['fuel_recent_rego']['fleet_id_num'] + '(' + data['fuel_recent_rego']['rego']  + ')';
                  }else{ this.fuelRecentRego = '-';};
                this.fuelRecentDate = data['fuel_recent_date'];
            });
                setTimeout(() => { this.loadingIndicator = false; }, 500);
        }else{
            await this.NewfuelService.getNewFuelSummary().toPromise().then(data => {
                this.fuelYearly = data['fuel_yearly'];
                this.fuelMonthly = data['fuel_monthly'];
                this.fuelWeekly = data['fuel_weekly'];
                this.fuelRecentCost = data['fuel_recent_cost'];
                if( data['fuel_recent_rego'] !== null){
                    this.fuelRecentRego = data['fuel_recent_rego']['fleet_id_num'] + '(' + data['fuel_recent_rego']['rego']  + ')';
                  }else{ this.fuelRecentRego = '-';};
                this.fuelRecentDate = data['fuel_recent_date'];
            });
            setTimeout(() => { this.loadingIndicator = false; }, 500);
        }
    }

    onChangeofOptions(selected) {
        console.log('changing to', selected);
        if (selected == 'week') {
            this.myDropDown =  'week'
            this.dateFilter = 'This Week'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == 'month') {
            this.myDropDown =  'month'
            this.dateFilter = 'Month'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else 
        if (selected == 'year') {
            this.myDropDown =  'year'
            this.dateFilter = 'This Year'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == 'today') {
            this.myDropDown =  'today'
            this.dateFilter = 'Today'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == '7') {
            this.myDropDown =  '7'
            this.dateFilter = 'Last 7 Days'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == '14') {
            this.myDropDown =  '14'
            this.dateFilter = 'Last 14 Days'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == '30') {
            this.myDropDown =  '30'
            this.dateFilter='Last 30 Days'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        else
        if (selected == '90') {
            this.myDropDown =  '90'
            this.dateFilter = 'Last 90 Days'
            this.showFilters = false;
            this.getFuels(this.myDropDown);
            this.getItems(this.myDropDown);
        }
        // else
        // if (selected == 'Custom') {
        //     this.myDropDown =  'year'
        //     this.dateFilter = 'Custom'
        //     this.showFilters = true;
        //     this.getFuels(this.myDropDown);
        //     this.getItems(this.myDropDown);
        // }
        else if(selected == 'range'){
            this.myDropDown = 'range';
            this.showFilters = false;
            this.processFuelDateRange('');
            this.getItems(this.myDropDown);
        }
        else if(selected == 'all'){
            this.showFilters = true;
            this.getFuels('all');
            this.getItems('all');
        }
    }

    computeFuelSubtotals() {
        this.totalFuelAmount = 0;
        this.totalFuelLitres = 0;
        this.totalFuels = 0;
        if (this.fuel_rows[0]) {
            let sum: number = this.fuel_rows.map(a => a.cost).reduce(function(a, b)
            {
            return a + b;
            });
            this.totalFuelAmount = sum;

            let sumLitres: number = this.fuel_rows.map(a => a.litres).reduce(function(a, b)
            {
                return a + b;
            });
            this.totalFuelLitres = sumLitres;
            this.totalFuels = this.fuel_rows.length;
        }
        this.averageFuelAmount = (this.totalFuelAmount / this.totalFuels) || 0;
    }

    fuel_columns = [
        { prop: 'id' },
        { prop: 'fleet_id' },
        { prop: 'driver_id' },
        { prop: 'cost' },
        { prop: 'litres' },
        { prop: 'receipt_no' },
        { prop: 'note' },
        { prop: 'file' },
        { prop: 'driver' },
        { prop: 'provider_id' },    
        { prop: 'rego' },    
    ];

    items_columns = [
        { prop: 'id'},
        { prop: 'fuel_id'},
        { prop: 'fuel_type_id'},
        { prop: 'rate_id'},
        { prop: 'quantity'},
        { prop: 'total'},
        { prop: 'created_at'},
        { prop: 'updated_at'},
        { prop: 'name'},
        { prop: 'rate'},
        { prop: 'gst'},
        { prop: 'rate_dollar'},
        { prop: 'rate_gst'},
    ];

    initFuelForm() {
        const numbers = '^[0-9]+$';
        this.fuelForm = this._fb.group({
            id              : [''],
            fleet_id        : ['', Validators.required], 
            driver_id       : ['', Validators.required],
            provider_id     : ['', Validators.required],
            fuel_card_id    : [''],
            fuel_type       : [''],
            hours           : [''],
            fault           : [''],
            cost            : [''],
            litres          : [''],
            date            : ['', Validators.required],
            time            : [''],
            time_string     : [{hour: 1, minute: 30}, Validators.required],
            odometer        : ['', Validators.compose([Validators.required, Validators.pattern(numbers)])],
            receipt_no      : [''],
            note            : [''],
            file            : ['', Validators.required],
            docket_file     : ['', Validators.required],
            lat             : [''],
            lng             : [''],
            location        : ['', Validators.required],
            fuel_items      : ['', Validators.required],
            file1           : [''],
            manifest_id     : [''],
            job_id          : [''],
            rego            : [''],
            driver_name     : [''],
            user_id         : [this.user['id']],
            map             : [''],
            hasFile         : [''],
            fileCount       : ['']
        });
    }

    initItemForm() {
        const currencyRegex = '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2,4})?$';
        this.itemForm = this._fb.group({
            id              : [''],
            fuel_type_id    : ['', Validators.required],
            name            : [''],
            quantity        : ['', [Validators.required, Validators.pattern(currencyRegex), Validators.min(0.01)]],
            rate            : ['', Validators.min(0.01)],
            gst             : [''],
            total           : ['', [Validators.required, Validators.pattern(currencyRegex), Validators.min(0.01)]]
        });
    }

    getManifests(fleet_id, fdate){
        this.NewfuelService.getManifests(fleet_id,fdate).subscribe(m=>{
            this.manifests = m['manifests'];
        })
    }

    getFuelCards(fleet_id, provider_id){
        this.NewfuelService.getFuelCardsForFuels(fleet_id,provider_id).subscribe(fc=>{
            this.fuel_cards = fc['fuel_cards'];
        })
    }

    showSubForm : boolean = false;
    
    toggleSubForm(){
        let has_date, has_fleet, has_provider = false;

        if(this.fuelForm.controls.date.valid){
            has_date = true;
        } 

        if(this.fuelForm.controls.fleet_id.valid){
            has_fleet = true;
            this.fuelForm.controls.fuel_card_id.setValue(null);
        } 

        if(this.fuelForm.controls.provider_id.valid){
            has_provider = true;
            this.fuelForm.controls.fuel_card_id.setValue(null);
        } 

        if(has_date && has_fleet && has_provider){
            this.showSubForm = true;

            //getFuelCards
            this.getFuelCards(this.fuelForm.controls.fleet_id.value, this.fuelForm.controls.provider_id.value)
            //getManifests
            this.getManifests(this.fuelForm.controls.fleet_id.value, this.fuelForm.controls.date.value)
        }else{
            this.showSubForm = false;
        }
    }

    checkCardValidity(fc_id){
        let target = true;
        if(this.fuel_cards.find(temp=>temp.id==fc_id)){
            target = false;
        }
        return target;
    }

    checkDriverStatus(status){
        let target = false;
        if(status == 0){
            target = true;
        }
        return target;
    }

    assignRego(){
        this.fleet.forEach(f=>{
            let fId = this.fuelForm.controls.fleet_id.value;
            if(fId !=0 && fId != ''){
                if(fId == f.id){
                    this.fuelForm.controls.rego.setValue(f.rego);
                }
            }
        })
    }

    assignDriverName(){
        this.drivers.forEach(d=>{
            let dId = this.fuelForm.controls.driver_id.value;
            if(dId !=0 && dId != ''){
                if(dId == d.id){
                    this.fuelForm.controls.driver_name.setValue(d.full_name);
                }
            }
        })
    }

    populateJob(){
        this.manifests.forEach(m=>{
            let mId = this.fuelForm.controls.manifest_id.value;
            if(mId != 0 && mId != ''){
                if(mId == m.manifest_id ){
                    this.fuelForm.controls.job_id.setValue(m.job_id);
                }
            }
        })
    }
    
    toggleSideBar(){
        if(this.showSidebar== false){
            this.loadingIndicator = true;
            this.showSidebar = true;
            setTimeout(() => { this.loadingIndicator = false; }, 100);
        }
        else {
            this.loadingIndicator = true;
            this.showSidebar = false;
            setTimeout(() => { this.loadingIndicator = false; }, 100);
        }
        this.getFuels(this.myDropDown);
    }

    public toggleFilters() {
        if (this.showFilters) this.showFilters = false;
        else this.showFilters = true;
    }

    public getFile(event, caller){
        console.log("EVENT",event)
        var assetFilename;
        var str = event.file.type //determines file type of file selected
    
        if (event == '' || event == null){
          assetFilename = event
        } else {
          if (str.indexOf("image") == -1 ) { 
            this.toaster.error('', 'File should be an image', {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
            assetFilename = null
            this.is_image = false;
          } else{
            if (this.isEditMode){
            console.log("EDITMODE")
            var file : ImageResult;
            file = event;
            assetFilename =  file.file.name;
            this.frmFile = event;
       
            this.fuelForm.controls.docket_file.setValue(assetFilename);
            this.fuelForm.controls.file1.setValue(file.dataURL);
            this.is_image=true;
            }
            else{
                console.log("ADD")
                var file : ImageResult;
                file = event;
                assetFilename =  file.file.name;
                this.frmFile = event;
                this.fuelForm.controls.docket_file.setValue(assetFilename);
                this.fuelForm.controls.file.setValue(assetFilename);
                this.fuelForm.controls.file1.setValue(file.dataURL);
                this.is_image=true;
            }
          }
        }
    }

    async uploadFile(caller, filename){
        if (this.frmFile){
            await this.fileService.uploadRawFileWithRename(caller, this.frmFile, filename).subscribe(file=>{
        
                if(file["data"] != filename)
                {
                    this.fuel.file = file["data"];
                    this.fuel.docket_file = file["data"];
                }
            });
        }
    
        this.frmFile = '';
    
        //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){

            //delete uploading image file
            if(this.fuel.docket_file != null || this.fuel.docket_file != '')
            {
                this.deleteFile(caller, this.oldDocketFile);// delete image file
            }  
            
            this.deleteFile(caller, this.oldFile);// delete report file
         
        };
    }
    
    public removeFile(caller){
        this.fileExists  = false;

        switch (caller){
        case  this.prefixFuel:
        { this.fuelForm.controls.docket_file.setValue(''); break;}
        }      
        this.fileRemove = true;
    }

    public deleteFile(caller, filename){
        this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
    }
    
    public resetFileVariables(){
        // for document file handling variables; checking if file exists or removed
        this.fileExists = false;
        this.fileRemove  = false;
        this.oldFile = '';
        this.oldDocketFile = '';
    }

    public resetFilters(caller) {

        if(caller == this.prefixFuel){
            this.filterFuelRego = '';
            this.filterFuelDateFrom = null;
            this.filterFuelDateTo = null;
            this.filterFuelProvider = '';
            this.filterCustomer = '';
            this.filterFuelItemProduct = '';
            this.filterLiter = null;
            this.filterCost = null;

            this.tempFuelCount = 0;
            this.tempFuelTotalCost = 0;
            this.tempFuelTotalLiter = 0;
            this.tempFuelAvgCost =0;

            this.fuel_rows = this.fullRowsFuel;
            this.fuelCount = this.fuel_rows.length;

            if(this.fuel_rows.length>0){
            this.selected = [this.fuel_rows[0]]
            }else{
            this.selected = [];
            }
            this.getFuels(this.myDropDown)
        }
       
        if(caller = this.prefixItem){
            this.tempItemCount = 0;
            this.tempItemTotalCost = 0;
            this.tempItemTotalLiter = 0;
            this.tempItemAvgCost =0;
        
            this.filterItemFuelId  = '';
            this.filterItemProvider = '';
            this.filterItemDateFrom = null;
            this.filterItemDateTo = null;
            this.filterItemCost = null;
            this.filterItemProduct = null;
            this.fuelData = this.fullRowsItem;
            this.itemCount = this.fuelData.length;

            if(this.fuelData.length>0){
                this.selected2 = [this.fuelData[0]]
            }else{
                this.selected2 = [];
            }
            this.getItems(this.fuelItemDateDropdown);
        }

        this.isFilterEmpty = true;
    }

    updateFilter(caller:string) {
        this.isFilterEmpty = false;
        switch (caller){
        
            case this.prefixFuel :{
                this.tempFuel = this.fullRowsFuel.filter(data => {
                if (this.filterFuelRego && data.rego){
                    return data.rego.toLowerCase().indexOf(this.filterFuelRego.toLowerCase()) !== -1 || !this.filterFuelRego.toLowerCase();    
                }else{
                    return data.rego;
                }
                });

                if(this.filterCost){
                    this.tempFuel = this.tempFuel.filter(data => { 
                    if (data.cost !== null && data.cost !== ''){
                    return data.cost.toString().toLowerCase().indexOf(this.filterCost.toString().toLowerCase()) !== -1 || !this.filterCost.toString().toLowerCase();      
                    }
                    else{
                    return data.cost
                    };
                    });
                    }
            
            if (this.filterFuelProvider){
            this.tempFuel = this.tempFuel.filter(data => {
                if(data.provider_id && this.filterFuelProvider){
                    return data.provider_id == this.filterFuelProvider;      
                }else{
                    return data.provider_id;
                }
                }); }


            if (this.filterCustomer){
                this.tempFuel = this.tempFuel.filter(data => {
                    if(data.customer && this.filterCustomer){
                    return data.customer.toLowerCase().indexOf(this.filterCustomer.toLowerCase()) !== -1 || !this.filterCustomer.toLowerCase();      
                    }else{
                        return data.customer;
                    }
                });}

                if (this.filterFuelItemProduct){
                    this.tempFuel = this.tempFuel.filter(data => {
                        if(data.fuel_product && this.filterFuelItemProduct){
                        return data.fuel_product.toLowerCase().indexOf(this.filterFuelItemProduct.toLowerCase()) !== -1 || !this.filterFuelItemProduct.toLowerCase();      
                        }else{
                            return data.fuel_product;
                        }
                    });}
            
                if(this.filterLiter){
                    this.tempFuel = this.tempFuel.filter(data => {
                    if (data.litres !== null && data.litres !== ''){
                    return data.litres.toString().toLowerCase().indexOf(this.filterLiter.toString().toLowerCase()) !== -1 || !this.filterLiter.toString().toLowerCase();      
                    }
                    else{
                    return data.litres
                    };
                    });
                    }
            
                this.tempFuel = this.tempFuel.filter(data => { 
                if (data.date && (this.filterFuelDateFrom && this.filterFuelDateTo)){
                    return ( new Date(data.date) >= new Date(this.filterFuelDateFrom) && new Date(data.date) <= new Date(this.filterFuelDateTo));   
                }else{
                    return data.date;
                };
                });
                this.getFuelSummary(this.tempFuel);
                this.computeFuelSubtotals();
                this.fuel_rows = this.tempFuel;
                this.fuelCount = Object.keys(this.tempFuel).length;

                if(this.fuel_rows.length>0){
                    this.selected = [this.fuel_rows[0]]
                    this.getFuelItemsByFuel(this.selected[0].id, 'loading');
                }else{
                    this.selected = [];
                }
                this.totalFuelAmount = 0;
                this.totalFuelLitres = 0;
                this.totalFuels = 0;
                if (this.fuel_rows[0]) {
                let sum: number = this.fuel_rows.map(a => a.cost).reduce(function(a, b)
                {
                return a + b;
                });
                this.totalFuelAmount = sum;

                let sumLitres: number = this.fuel_rows.map(a => a.litres).reduce(function(a, b)
                {
                    return a + b;
                });
                this.totalFuelLitres = sumLitres;
                this.totalFuels = this.fuel_rows.length;
            }
            this.averageFuelAmount = (this.totalFuelAmount / this.totalFuels) || 0;
            }
        
            case this.prefixItem:{
                this.tempItem = this.fullRowsItem;

                if(this.filterItemCost){
                    this.tempItem = this.tempItem.filter(data => { 
                    if (this.filterItemCost && data.total){
                    return data.total.toString().toLowerCase().indexOf(this.filterItemCost.toLowerCase()) !== -1 || !this.filterItemCost.toLowerCase();      
                    }
                    else{
                    return data.total
                    };
                    });
                    }
            
                if (this.filterItemFuelId){
                this.tempItem = this.tempItem.filter(data => {
                if (this.filterItemFuelId && data.fuel_id){
                    return data.fuel_id.toString().toLowerCase().indexOf(this.filterItemFuelId.toLowerCase()) !== -1 || !this.filterItemFuelId.toLowerCase();          
                }else{
                    return data.fuel_id;
                }
                });}

                if (this.filterItemProduct){
                    this.tempItem = this.tempItem.filter(data => {
                        if (this.filterItemProduct && data.fuel_type_id){
                            return data.fuel_type_id == this.filterItemProduct;          
                        }else{
                            return data.fuel_type_id;
                        }
                    });
                };

                if (this.filterItemDateFrom && this.filterItemDateTo)
                this.tempItem = this.tempItem.filter(data => {

                if (data.created_at && (this.filterItemDateFrom && this.filterItemDateTo)){
                    return ( new Date(data.created_at) >= new Date(this.filterItemDateFrom) && new Date(data.created_at) <= new Date(this.filterItemDateTo));   
                }else{
                    return data.created_at;
                };
                });
                
                this.getFuelItem(this.tempItem)
                this.fuelData = this.tempItem;
                this.itemCount = Object.keys(this.tempItem).length;
                this.computeFuelItemSubtotals()
                if(this.fuelData.length>0){
                    this.selected2 = [this.fuelData[0]];
                }else{
                    this.selected2 = [];
                } 
                this.totalFuelItemAmount = 0;
                this.totalFuelItemLitres = 0;
                this.totalFuelItems = 0;
                if (this.fuelData[0]) {
                    let sum: number = this.fuelData.map(a => a.total).reduce(function(a, b)
                    {
                    return a + b;
                    });
        
                    this.totalFuelItemAmount = sum;
        
                    let sumLitres: number = this.fuelData.map(a => a.quantity).reduce(function(a, b)
                    {
                        return a + b;
                    });      
                    this.totalFuelItemLitres = sumLitres;
                    this.totalFuelItems = this.fuelData.length;
                }
                this.averageFuelItemAmount = (this.totalFuelItemAmount / this.totalFuelItems) || 0;
            }
            default: {break;}
        }
    }

    public getFuelSummary(tempFuel){
        this.tempFuelTotalCost = 0;this.tempFuelTotalLiter = 0;
        this.tempFuelAvgCost = 0; this.tempFuelCount = 0;    

        if(tempFuel.length === this.fullRowsFuel.length){
          this.tempFuelTotalCost = 0;
          this.tempFuelTotalLiter = 0;
          this.tempFuelAvgCost = 0;
          this.tempFuelCount = 0;    
        } else {
          for(let i = 0; i < tempFuel.length; i++){
            this.tempFuelTotalLiter = this.tempFuelTotalLiter + tempFuel[i].litres;
            this.tempFuelTotalCost = this.tempFuelTotalCost + tempFuel[i].cost;
          }
         
          this.tempFuelCount = tempFuel.length;
          this.tempFuelAvgCost = this.tempFuelTotalCost / this.tempFuelTotalLiter
        }
    }

    public getFuelItem(tempItem){
        this.tempItemTotalCost = 0;this.tempItemTotalLiter = 0;
        this.tempItemAvgCost = 0; this.tempItemCount = 0;    
  
        if(this.tempItem.length === this.fullRowsItem.length){
          this.tempItemTotalCost = 0;
          this.tempItemTotalLiter = 0;
          this.tempItemAvgCost = 0;
          this.tempItemCount = 0;    
       
        } else {
          for(let i = 0; i < tempItem.length; i++){
            this.tempItemTotalLiter = this.tempItemTotalLiter + tempItem[i].quantity;
            this.tempItemTotalCost = this.tempItemTotalCost + tempItem[i].total;
          }
        
          this.tempItemCount = tempItem.length;
          this.tempItemAvgCost = this.tempItemTotalCost / this.tempItemTotalLiter
        }
    }


    processFuelDateRange(event) {
        console.log('processing range');
        // if (event.start != undefined && event.end != undefined){
        var start = moment(this.fuelDateRange.start?._d).format('YYYY-MM-DD');
        var end = moment(this.fuelDateRange.end?._d).format('YYYY-MM-DD');
        this.getFuels('range',start, end);
        // }
      }
    
    onSelect1({ selected }) {
        this.getFuelItemsByFuel(this.selected[0].id, 'loading');
        this.selected[0].fuel_items = this.tempItems;

    }
    onActivate1(event) {
    }

    openDeleteFuelModal(fuel: Fuel): void {
        if(fuel){
          this.fuel = fuel;
        }     
        this.modalRef = this.modal.open(this.modalDeleteFuel, { size: 'sm', backdrop: 'static'});
    }
    
    openDeleteItemModal(item: FuelItem): void { 
        if(item){
          this.item = item;
        } 
        this.modalRef = this.modal.open(this.modalDeleteItem, { size: 'sm', backdrop: 'static'});
    }

    removeItem(i){
        this.grandLiter = Number(parseFloat((this.grandLiter - this.tempItems[i].quantity).toString()).toFixed(2));
        this.grandTotal = Number(parseFloat((this.grandTotal - this.tempItems[i].total).toString()).toFixed(2));
        this.tempItems.splice(i, 1);
        this.fuelForm.controls.fuel_items.patchValue(JSON.parse(JSON.stringify(this.tempItems)));
    }
    
      async deleteItem(item: FuelItem) {
        this.spinner = true;
        await this.NewfuelService.deleteItem(item.id).toPromise().then(result => {
            console.log("result",result)
			this.toaster.success('', 'Successfully Deleted Item From Fuel', {
				timeOut: 5000,
				positionClass: 'toast-top-full-width',
				progressBar: true
            });
            this.getItems(this.fuelItemDateDropdown);
            
        }).catch(err =>{
                this.toaster.error("Please try again.", "There was a problem with deleting the selected item entry", {
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                });
        }).finally(() => {
            this.getItems(this.fuelItemDateDropdown);
        this.modalRef.close();  
        }); 
        this.spinner = false;    
    }

    async deleteFuel(fuel : Fuel) {
        this.spinner = true;
        const delete_fuel =  {
            fuel_id: fuel.id,
            user_id: this.user['id']
        }
        if(fuel.file != null && fuel.file != ''){
            this.deleteFile(this.prefixFuel, fuel.file);
        }
  
        await this.NewfuelService.deleteFuel(delete_fuel).toPromise().then(result => {     
            this.toaster.success('', result["message"], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
        }).catch(err =>{
            this.toaster.error("Please try again.", "There was a problem with deleting the selected fuel record", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
        }).finally(() => {
            this.refreshData.emit();
            this.getFuels(this.myDropDown);     
        });
        this.modalRef.close(); 
        this.spinner = false;
    }
  
    public closeModal(){
        this.modalRef.close();
        this.fuelForm.reset();
        this.showSubForm = false;
        this.resetFileVariables();
        this.grandLiter = 0;
        this.grandTotal = 0;
        this.spinner = false;
    }

    openFuelModal(fuel: Fuel): void { 
        if(fuel){
          fuel['time_string'] = {hour: fuel['hour'], minute: fuel['minute']};  
          this.isEditMode = true;
          this.fuel = fuel;
          this.getFuelItemsByFuel(this.fuel.id, 'modal');
          if (this.fuel.file != null && this.fuel.file != '' && this.fuel.docket_file != null && this.fuel.docket_file != ''){
            this.oldFile = this.fuel.file;
            this.oldDocketFile = this.fuel.docket_file;
            this.fileExists = true;
          }
            this.getFuelCards(this.fuel.fleet_id, this.fuel.provider_id);
            this.getManifests(this.fuel.fleet_id, this.fuel.date);
            this.fuelForm.patchValue(this.fuel);
            }
            else{
            this.isEditMode = false;
            this.fuel = new Fuel();
            this.tempItems = [];
            this.fuel_cards = this.fuel_cards_all;
            this.grandTotal = 0;
            this.grandLiter = 0;
            this.fuelForm.reset();
            this.itemForm.reset();

            if (this.fleet_id != 0 && this.fleet_id!= null){console.log('here');
                this.fuelForm.controls.fleet_id.setValue(this.fleet_id);this.assignRego();
            };
        }   
        this.modalRef = this.modal.open(this.modalFuel, { size: 'lg', backdrop: 'static'});
}     
    
    public createFuel(fuel: Fuel) { 
        fuel.user_id = this.user['id'];
        this.spinner = true;
        if((Object.keys(this.tempItems).length == 0)){
            this.toaster.error('', 'Your Fuel Cost should have at least one item', {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        } else 
        if(this.fuel.file == null){
            this.toaster.error('', 'Image file required for fuel cost', {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        }else{
            if(this.is_image == false){
            this.toaster.error('', 'Image file required for fuel cost', {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
            } else {
                this.NewfuelService.createFuel(fuel).subscribe(fuel => {
                    
                    this.toaster.success('', 'Successfully Saved Fuel',{
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                    });
                    this.getFuels(this.myDropDown);
                    this.getItems(this.fuelItemDateDropdown);
                    
                    }, err =>{
                    this.toaster.error("Please try again.", "There was a problem with creating new fuel record", {
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        progressBar: true
                    });
                });
           }
        }
        this.spinner = false;
    }
    
    toggleItem(){
        if(this.showItem== false){
            this.showItem = true;
        }else{
            this.showItem = false;
        }
        this.initItemForm();
    }
      
    public updateFuel(fuel:Fuel) {
        this.spinner = true;
        if(Object.keys(this.tempNewItems).length == 0 && this.itemCount ==0){
            this.toaster.error('', 'Your Fuel Cost should have at least one item', {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        } else 
        if(this.fuel.file == null){
            this.toaster.error('', 'Image file required for fuel cost', {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        }else{
            if(this.is_image == false){
            this.toaster.error('', 'Image file required for fuel cost', {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
            });
            } else {
                this.NewfuelService.updateFuel(fuel).subscribe(fuel => {

                this.toaster.success('', 'Successfully Saved Fuel',{
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
                });
                this.getFuels(this.myDropDown);
                
                }, err =>{
                this.toaster.error("Please try again.", "There was a problem with creating new fuel record", {
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                });
            });
            }
        }
        this.spinner = false;
    }

    async onSubmitFuel(fuel: Fuel){
        this.spinner = true;
        this.fuel = fuel;
        this.fuel.cost = this.grandTotal;
        this.fuel.litres = this.grandLiter;
        if (this.fuel['time_string'] != null)
        {
          this.fuel.time = this.fuel['time_string'].hour + ":" + this.fuel['time_string'].minute + ":00";
        }
        else{
          this.fuel.time = '00:00:00'
        }

        if(fuel.id && this.isEditMode == true){
          this.updateFuel(this.fuel);  
        } else {
          this.createFuel(this.fuel);
        }
    
        this.closeModal();
        this.modal.dismissAll();       
    }

    public onSubmitItem(item: FuelItem){
    this.spinner = true;
    this.item = item;
    this.item.gst = 1 //gst included 

    this.item.rate = item.total / item.quantity;
    this.item.rate = Number(parseFloat(this.item.rate.toString()).toFixed(3));
    

    if(this.itemForm.valid){
        if(item.id){
        
        } else {       
        this.grandTotal = Number(parseFloat((+this.grandTotal +  +this.item.total).toString()).toFixed(2));
        this.grandLiter = Number(parseFloat((+this.grandLiter +  +this.item.quantity).toString()).toFixed(2));
        this.tempItems.push(this.item);
        this.initItemForm();   
        this.fuelForm.controls.fuel_items.patchValue(JSON.parse(JSON.stringify(this.tempItems)));
        }
    }
    this.spinner = false;   
    }

    onChangeFuelItemDateDropdown(selected) {
        console.log('changing fuel item date to', selected);
        if (selected == 'week') {
            this.fuelItemDateDropdown =  'week';
            this.fuelItemDateFilterLabel = 'This Week';
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == 'month') {
            this.fuelItemDateDropdown =  'month'
            this.fuelItemDateFilterLabel = 'Month'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else 
        if (selected == 'year') {
            this.fuelItemDateDropdown =  'year'
            this.fuelItemDateFilterLabel = 'This Year'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == 'today') {
            this.fuelItemDateDropdown =  'today'
            this.fuelItemDateFilterLabel = 'Today'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == '7') {
            this.fuelItemDateDropdown =  '7'
            this.fuelItemDateFilterLabel = 'Last 7 Days'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == '14') {
            this.fuelItemDateDropdown =  '14'
            this.fuelItemDateFilterLabel = 'Last 14 Days'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == '30') {
            this.fuelItemDateDropdown =  '30'
            this.fuelItemDateFilterLabel='Last 30 Days'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        else
        if (selected == '90') {
            this.fuelItemDateDropdown =  '90'
            this.fuelItemDateFilterLabel = 'Last 90 Days'
            this.showFilters = false;
            this.getItems(this.fuelItemDateDropdown);
        }
        // else
        // if (selected == 'Custom') {
        //     this.fuelItemDateDropdown =  'year'
        //     this.fuelItemDateFilterLabel = 'Custom'
        //     this.showFilters = true;
        //     this.getItems(this.fuelItemDateDropdown);
        // }
        else if(selected == 'range'){
            this.fuelItemDateDropdown = 'range';
            this.showFilters = false;
            this.processFuelItemDateRange('');
        }
        else if(selected == 'all'){
            this.showFilters = true;
            this.getItems('all');
        }
    }

    computeFuelItemSubtotals() {
        this.totalFuelItemAmount = 0;
        this.totalFuelItemLitres = 0;
        this.totalFuelItems = 0;
        if (this.fuelData[0]) {
            let sum: number = this.fuelData.map(a => a.total).reduce(function(a, b)
            {
            return a + b;
            });

            this.totalFuelItemAmount = sum;

            let sumLitres: number = this.fuelData.map(a => a.quantity).reduce(function(a, b)
            {
                return a + b;
            });

            this.totalFuelItemLitres = sumLitres;
            this.totalFuelItems = this.fuelData.length;
        }
        this.averageFuelItemAmount = (this.totalFuelItemAmount / this.totalFuelItems) || 0;
    }

    processFuelItemDateRange(event) {
        console.log('processing item range');
        // if (event.start != undefined && event.end != undefined){
        var start = moment(this.fuelItemDateRange.start?._d).format('YYYY-MM-DD');
        var end = moment(this.fuelItemDateRange.end?._d).format('YYYY-MM-DD');
        console.log(start + ' to ' + end);
        this.getItems('range',start, end);
        // }
      }

    /*** Export... Module ***/
    //Replaces an attribute name for reading comprehension
    renameKey( obj, oldKey, newKey ) {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    }

    //Formats readable header names in the given table
    generateHeaders(list_fleetAsset): any{
        const arr = JSON.parse(list_fleetAsset);
        arr.forEach( obj => {
        this.renameKey( obj, 'date', 'Date' );
        this.renameKey( obj, 'week_no', 'Week No' );
        this.renameKey( obj, 'fuel_id', 'Fuel ID' );
        this.renameKey( obj, 'rego', 'REGO' );
        this.renameKey( obj, 'fleet_id_num', 'Fleet ID' );
        this.renameKey( obj, 'name', 'Product' );
        this.renameKey( obj, 'rate', 'Rate ($)' );
        this.renameKey( obj, 'quantity', 'Quantity No.' );
        this.renameKey( obj, 'total', 'Total' );
        this.renameKey( obj, 'driver_name', 'Driver' );
        this.renameKey( obj, 'company_name', 'Supplier' );
        this.renameKey( obj, 'card_no', 'Card No.' );
        this.renameKey( obj, 'cost', 'Cost' );
        this.renameKey( obj, 'litres', 'Litres' );
        this.renameKey( obj, 'file', 'File' );
        });
        const updatedJson = JSON.stringify( arr );
        return updatedJson;
    }

    //Filters every column in the Fuel Cost table list
    fuelCost_generateColumnsWithFilter(list_fuelCost){
        const arr = JSON.parse(JSON.stringify(list_fuelCost));
        arr.forEach( obj => {

            obj['date'] = formatDate(obj['date'], 'dd-MM-yyyy', 'en_US');

            //remove filtered columns
            if(!this.showDate){
                delete obj['date'];
            };
            if(!this.showWeekNo){
                delete obj['week_no'];
            };
            if( !this.showRego){
                delete obj['rego'];
            };
                if( !this.showFleetID){
            delete obj['fleet_id_num'];
            };
            if(!this.showDriver){
                delete obj['driver_name'];
            };
            if(!this.showSupplier){
                delete obj['company_name'];
            };
            if(!this.showCardNo){
                delete obj['card_no'];
            };
            if(!this.showCost){
                delete obj['cost'];
            };
            if(!this.showLitres){
                delete obj['litres'];
            };
            if(!this.showFile){
                delete obj['file'];
            };
            delete obj['id'];
            delete obj['fuel_product']
            delete obj['fuel_items'];
            delete obj['control_no'];
            delete obj['customer'];
            delete obj['card_name'];
            delete obj['updated_at'];
            delete obj['time'];
            delete obj['receipt_no'];
            delete obj['provider_id'];
            delete obj['odometer'];
            delete obj['note'];
            delete obj['location'];
            delete obj['lng'];
            delete obj['lat'];
            delete obj['job_id'];
            delete obj['hours'];
            delete obj['fuel_type'];
            delete obj['fuel_card_id'];
            delete obj['fleet_id'];
            delete obj['fault'];
            delete obj['driver_id'];
            delete obj['docket_file'];
            delete obj['created_at'];
        });
        const updatedJson = JSON.stringify( arr );
        return updatedJson;                         
    }

    //Exports Fuel Cost table to CSV file
    fuelCost_exportToCSV(){
        if(this.fuel_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.fuelCost_generateColumnsWithFilter(this.fuel_rows);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let csv_file = '[TMS]Fleet_Fuel_Costs_' + this.formattedDate(current_date);
            this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Asset - Fuel Costs');
        }
    };

    //Exports Fuel Cost table to PDF file
    fuelCost_exportToPDF(){
        if(this.fuel_rows.length >0){
            let with_header_format, with_column_filter;
      
            //generate json with filtered column
            with_column_filter = this.fuelCost_generateColumnsWithFilter(this.fuel_rows);
      
            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);
      
            //export to file
            let current_date = new Date();
            let pdf_file = '[TMS]Fleet_Fuel_Costs_' + this.formattedDate(current_date);
            this.exp_pdf.title = 'FUEL COSTS';
            this.exp_pdf.type = 'pdf';
            this.exp_pdf.list_data = this.formatted_list;
            this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
              saveAs(data, pdf_file + '.' + this.exp_pdf.type);
            });
          }
    };
  
    //Exports Fuel Cost table to MS Excel file
    fuelCost_exportToExcel(){
        if(this.fuel_rows.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.fuelCost_generateColumnsWithFilter(this.fuel_rows);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let excel_file = '[TMS]Fleet_Fuel_Costs_' + this.formattedDate(current_date);
            this.exp_excel.title = 'FUEL COSTS';
            this.exp_excel.type = 'xlsx';
            this.exp_excel.list_data = this.formatted_list;
            this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
                console.log(data);
                saveAs(data, excel_file)

            });
        }
    };

    //Filters every column in the Fuel Items table list
    fuelItems_generateColumnsWithFilter(list_fuelItems){
        const arr = JSON.parse(JSON.stringify(list_fuelItems));
        arr.forEach( obj => {

            obj['date'] = formatDate(obj['date'], 'dd-MM-yyyy', 'en_US');

            //remove filtered columns
            if(!this.showDateCreated){
                delete obj['date'];
            };
            if(!this.showFuelItems_WeekNo){
                delete obj['week_no'];
            };
            if(!this.showFuelItems_FuelID){
                delete obj['fuel_id'];
            };
            if(!this.showFuelItems_Rego){
                delete obj['rego'];
            };
            if(!this.showFuelItems_FleetID){
                delete obj['fleet_id_num'];
            };
            if(!this.showProduct){
                delete obj['name'];
            };
            if(!this.showRate){
                delete obj['rate'];
            };
            if(!this.showQuantity){
                delete obj['quantity'];
            };
            if(!this.showTotal){
                delete obj['total'];
            };
            delete obj['id'];
            delete obj['created_at'];
            delete obj['fuel_type_id'];
            delete obj['rate_id'];
            delete obj['gst'];
            delete obj['rate_provider'];
        });
        const updatedJson = JSON.stringify( arr );
        return updatedJson;                         
    }

    //Exports Fuel Items table to CSV file
    fuelItems_exportToCSV(){
        if(this.fuelData.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.fuelItems_generateColumnsWithFilter(this.fuelData);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let csv_file = '[TMS]Fleet_Asset_Fuel_Items_' + this.formattedDate(current_date);
            this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Asset - Fuel Items');
        }
    };

    //Exports Fuel Items table to PDF file
    fuelItems_exportToPDF(){
        if(this.fuelData.length >0){
            let with_header_format, with_column_filter;

            //generate json with filtered column
            with_column_filter = this.fuelItems_generateColumnsWithFilter(this.fuelData);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let pdf_file = '[TMS]Fleet_Asset_Fuel_Items_' + this.formattedDate(current_date);
            this.exp_pdf.title = 'FUEL ITEMS';
            this.exp_pdf.type = 'pdf';
            this.exp_pdf.list_data = this.formatted_list;
            this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
              saveAs(data, pdf_file + '.' + this.exp_pdf.type);
            });
          }
    };
  
    //Exports Fuel Items table to MS Excel file
    fuelItems_exportToExcel(){
        if(this.fuelData.length >0){
            let with_header_format, with_column_filter;
            
            //generate json with filtered column
            with_column_filter = this.fuelItems_generateColumnsWithFilter(this.fuelData);

            //generate json with format header
            this.formatted_list = this.generateHeaders(with_column_filter);

            //export to file
            let current_date = new Date();
            let excel_file = '[TMS]Fleet_Asset_Fuel_Items_' + this.formattedDate(current_date);
            this.exp_excel.title = 'FLEET FUEL ITEMS';
            this.exp_excel.type = 'xlsx';
            this.exp_excel.list_data = this.formatted_list;
            this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
            console.log(data);
            saveAs(data, excel_file)

            });
       }
    };

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }


  resetFormControl(type){
    const pCtrl = (<any>this.fuelForm);
    if(type == 'manifest_id') pCtrl.controls.manifest_id.setValue('');
    if(type == 'fuel_card_id') pCtrl.controls.fuel_card_id.setValue('');
  }


  getCtrlValue(selected_ctrl) { 
    var dCtrl= null;
    if(selected_ctrl == 'manifest_id'){dCtrl = (<any>this.fuelForm).controls.manifest_id;};
    if(selected_ctrl == 'fuel_card_id'){dCtrl = (<any>this.fuelForm).controls.fuel_card_id;};
  
    return dCtrl.value; 
  }
}